var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.notification.eventId)?_c('div',[_c('button',{staticClass:"notification-action",on:{"click":_setup.handleProvideFeedback}},[_vm._v(" Leave a like and provide feedback "),_c(_setup.BKSvgIcon,{staticClass:"arrow-icon",attrs:{"color":"#ff2d53","height":"24px","name":"arrow-with-stem","width":"24px"}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }